export const getTarget = (url?: string) => {
    return url?.startsWith('http') ? '_blank' : undefined;
};
